
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26","height":"26","viewBox":"0 0 25.238 22.39"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff","stroke":"#fff","stroke-width":".5"}},[_c('path',{attrs:{"data-name":"Контур 1","d":"M13.756.455a1.44 1.44 0 00-1.469.021.442.442 0 00-.062.044L5.782 5.973H.725a.475.475 0 00-.475.475v9.034a.476.476 0 00.475.475H5.77l6.44 5.915a.464.464 0 00.077.057 1.44 1.44 0 001.469.021 1.484 1.484 0 00.759-1.31V1.768a1.486 1.486 0 00-.759-1.313zm-.192 20.182a.545.545 0 01-.275.483.5.5 0 01-.475.012l-6.383-5.86v-2.167a.475.475 0 10-.951 0v1.9H1.201V6.924H5.48v1.9a.475.475 0 00.951 0V6.669l6.374-5.392a.5.5 0 01.483.009.545.545 0 01.275.482z"}}),_c('path',{attrs:{"data-name":"Контур 2","d":"M18.694 2.194a.476.476 0 00-.306.9 8.313 8.313 0 01.011 15.742.476.476 0 00.154.926.469.469 0 00.154-.026 9.264 9.264 0 00-.013-17.542z"}}),_c('path',{attrs:{"data-name":"Контур 3","d":"M20.709 10.966a6.448 6.448 0 00-4.636-6.163.476.476 0 10-.263.914 5.464 5.464 0 010 10.5.476.476 0 00.132.932.484.484 0 00.132-.019 6.447 6.447 0 004.635-6.164z"}})])])
          )
        }
      }
    